import { defineAgenda, param } from '@/shared/navigation/core';

export const columbusDetailAgenda = defineAgenda({
  id: 'app.columbus-planner.detail',
  path: 'app/columbus-planner/detail',
  open: {
    productId: param.number(),
    termsSerialId: param.number(),
    destinationSeasonId: param.number(),
    termId: param.number().optional(),
  },
  title: 'Columbus Plánovač',
  icon: 'calendar-range',
});
